import { Box, BoxProps, styled } from '@mui/material';
import { useEffect, useState } from 'react';

interface IImageBoxProps extends BoxProps {
  src: string,
  alt?: string,
  isLoading?: any
}

const ImageContainer = styled(Box)`
  & img {
    width: 100%
  }
`;

interface PropsBgContainer {
  theme?: any,
  src: string,
}

const ImageBgContainer = styled(Box)(({theme, src}: PropsBgContainer ) => ({
  background: `url("${src}")`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}));

export const ImageBox = ({ src, alt, ...props }: IImageBoxProps) => {
  return (
    <ImageContainer {...props}>
      <img src={src} alt={alt || ''}/>
    </ImageContainer>
  );
};

export const ImageBoxBg = ({ src, isLoading, width, ...props }: IImageBoxProps) => {
  const [path, setPath] = useState(src);
  
  useEffect(() => {
    if(!isLoading) {
      setPath(src + '?' + Date.now());
    }
  },[isLoading, src]);
  
  
  return (
    <ImageBgContainer src={path} {...props} />
  );
};